import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { JQModal } from "./Popup/Utils";

interface Props {
	id: string;
	ariaLabel?: string;
}

class SimpleModal extends Component<Props> {
	render() {
		const close = () => {
			JQModal( this.props.id ).hide();
		};
		return (
			<div
				aria-hidden="true" aria-labelledby={ this.props.ariaLabel } className="modal fade"
				id={ this.props.id }
				role="dialog" tabIndex={ -1 }>
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{ Strings.my_dld }</h5>
							<button
								aria-label="Close" className="close modal-close-svg-icon" onClick={ close }
								type="button">
								<span className="close-svg-icon"/>
								<span className="sr-only">{ Strings.close }</span>
							</button>
						</div>
						<div className="modal-body">
							{ this.props.children }
							<div className="form-group mb-4 mb-0 text-center">
								<button
									aria-label="Close" className="btn btn_1" onClick={ close }
									type="button">{ Strings.close }
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SimpleModal;
